import { useContext } from 'react';
import { ChasersContext } from 'context/chasers';

const useChasersContext = () => {
  return useContext(ChasersContext);
};

export default useChasersContext;
